import { gridSizeMdLg6 } from '@/shared';
import {
  CustomTextArea,
  CustomTextField,
  TabTextLabel,
} from '@/shared/components/ui';
import CustomCellphoneTextField from '@/shared/components/ui/CustomCellphoneTextField';

export type OTDetalleClienteInstallTecnicoCorporativoFormTabProps = {
  //form: UseFormReturn<SaveFormDataInstallTecAsig, any>;
  form: any;
  errors: any;
  shrink: boolean;

  isOnlyView?: boolean;
};

const OTDetalleClienteInstallTecnicoCorporativoFormTab: React.FC<
  OTDetalleClienteInstallTecnicoCorporativoFormTabProps
> = ({ errors, form, shrink, isOnlyView }) => {
  return (
    <>
      <TabTextLabel text="Cliente" pb="24px" pt="12px" />

      <>
        <CustomTextField
          name="tipo_identificacion"
          label="Tipo de Identificación"
          control={form.control}
          defaultValue={form.getValues().tipo_identificacion || ''}
          error={errors.tipo_identificacion}
          helperText={errors.tipo_identificacion?.message?.toString() ?? ''}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />

        <CustomTextField
          name="identificacion"
          label="No. Identificación"
          control={form.control}
          defaultValue={form.getValues().identificacion || ''}
          error={errors.identificacion}
          helperText={errors.identificacion?.message?.toString() ?? ''}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />

        <CustomTextField
          name="razon_social"
          label="Razon social"
          control={form.control}
          defaultValue={form.getValues().razon_social || ''}
          error={errors.razon_social}
          helperText={errors.razon_social?.message?.toString() ?? ''}
          shrink={shrink}
          disabled
        />


        <CustomCellphoneTextField
          name="celular"
          label="Celular"
          control={form.control}
          defaultValue={form.getValues().celular || ''}
          error={errors.celular}
          helperText={errors.celular?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          // disabled={isOnlyView}
          disabled // x el codigo otp
        />
        <CustomCellphoneTextField
          name="celular_2"
          label="Celular 2"
          control={form.control}
          defaultValue={form.getValues().celular_2 || ''}
          error={errors.celular_2}
          helperText={errors.celular_2?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled={isOnlyView}
        />

        <CustomCellphoneTextField
          name="celular_3"
          label="Celular 3"
          control={form.control}
          defaultValue={form.getValues().celular_3 || ''}
          error={errors.celular_3}
          helperText={errors.celular_3?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled={isOnlyView}
        />

        <CustomTextField
          name="direccion_cliente"
          label="Dirección Cliente"
          control={form.control}
          defaultValue={form.getValues().direccion_cliente || ''}
          error={errors.direccion_cliente}
          helperText={errors.direccion_cliente?.message?.toString() ?? ''}
          shrink={shrink}
          disabled
        />

        <CustomTextField
          name="direccion_empresa"
          label="Dirección Empresa"
          control={form.control}
          defaultValue={form.getValues().direccion_empresa || ''}
          error={errors.direccion_empresa}
          helperText={errors.direccion_empresa?.message?.toString() ?? ''}
          shrink={shrink}
          disabled
        />

        <CustomTextField
          name="direccion_cliente"
          label="Dirección Cliente"
          control={form.control}
          defaultValue={form.getValues().direccion_cliente || ''}
          error={errors.direccion_cliente}
          helperText={errors.direccion_cliente?.message?.toString() ?? ''}
          shrink={shrink}
          disabled
        />



        {/* ------- Forma Pago ------- */}
        <TabTextLabel text="Forma Pago y Observaciones" pt="54px" pb="12px" />
        <>
          <CustomTextField
            name="forma_pago_data.alias"
            label="Forma de Pago"
            control={form.control}
            defaultValue={form.getValues().forma_pago_data?.alias || ''}
            error={errors.forma_pago}
            helperText={errors.forma_pago?.message?.toString() ?? ''}
            shrink={shrink}
            disabled
          />

          <CustomTextArea
            label="Observación 1 Vendendor"
            name="observacion_1"
            control={form.control}
            defaultValue={form.getValues().observacion_1 || ''}
            error={errors.observacion_1}
            helperText={errors.observacion_1?.message || ''}
            disabled
          />
          <CustomTextArea
            label="Observación 2 Vendendor"
            name="observacion_2"
            control={form.control}
            defaultValue={form.getValues().observacion_2 || ''}
            error={errors.observacion_2}
            helperText={errors.observacion_2?.message || ''}
            disabled
          />
          <CustomTextArea
            label="Observación Llamada"
            name="observacion_llamada"
            control={form.control}
            defaultValue={form.getValues().observacion_llamada || ''}
            error={errors.observacion_llamada}
            helperText={errors.observacion_llamada?.message || ''}
            disabled
          />
        </>
      </>
    </>
  );
};

export default OTDetalleClienteInstallTecnicoCorporativoFormTab;
